import { FormControl } from "./formControl";
export class Form {
    /**
     * Function for creating a Form
     * @remarks This allows us to specify the index signatures in the class
     */
    static create(initialData, notifyListeners) {
        return new Form(initialData, notifyListeners);
    }
    _notifyListeners;
    get valid() {
        let valid = true;
        this.forEachControl((formControl) => {
            if (!formControl.valid)
                valid = false;
        });
        return valid;
    }
    get touched() {
        let touched = true;
        this.forEachControl((formControl) => {
            if (!formControl.touched)
                touched = false;
        });
        return touched;
    }
    get values() {
        let values = {};
        this.forEachControl((formControl, key) => {
            values[key] = formControl.value;
        });
        return values;
    }
    set touched(value) {
        this.forEachControl((formControl) => {
            formControl.touched = value;
        });
        this._notifyListeners();
    }
    constructor(initialData, notifyListeners) {
        for (const [k, v] of Object.entries(initialData)) {
            this._addControl(k, v.initial, v.validators, [], v.errorMap);
        }
        this._notifyListeners = notifyListeners;
    }
    /** Reset the whole form */
    reset() {
        this.forEachControl((formControl) => formControl.reset());
    }
    /** @internal Add a form conrol to the Form */
    _addControl(name, initial = "", validators = [], elements = [], errorMap = {}) {
        this[name] = new FormControl({
            value: initial,
            validators: validators,
            elements: elements,
            errorMap: errorMap,
            formRef: () => this,
        });
    }
    forEachControl(callback) {
        for (const [key, value] of Object.entries(this)) {
            if (value instanceof FormControl) {
                callback(value, key);
            }
        }
    }
}
export class FormControlMissingError extends Error {
}
